import { ApolloClient, HttpLink, InMemoryCache, ApolloLink, from } from '@apollo/client/core'
import { onError } from '@apollo/client/link/error'
import signWrap from '@/apollo/sign'

const cache = new InMemoryCache()

const httpLink = new HttpLink({
  uri: process.env.VUE_APP_DMZ_API
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    console.error('请求异常，请稍后重试！')
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.log(`
        [GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
    )
  }

  // 网络错误处理
  if (networkError) console.log(`[Network error]: ${networkError}`)
})

const additiveLink = new ApolloLink((operation, forward) => {
  operation.setContext(() => ({
    headers: {
      'content-type': 'application/json',
      ...signWrap(operation)
    }
  }))

  return forward(operation).map(data => {
    console.log(data.data)
    return data
  })
})

const dmz = new ApolloClient({
  cache,
  link: from([additiveLink, errorLink, httpLink])
})

export default dmz
